import { GroupedArrayFilter } from './GroupedArrayFilter';

export default GroupedArrayFilter;
